import { Analytics } from './analytics';

let firstLevelMenuItem = $('[menu-item-link-primary-level-1]');
let secondLevelMenuItem = $('[menu-item-link-primary-level-2]');

let mobileFirstLevelMenuItem = $('[mobile-menu-item-link-primary-level-1]');
let mobileSecondLevelMenuItem = $('[mobile-menu-item-link-primary-level-2]');

firstLevelMenuItem.on("click", (e) => {
  Analytics.sendRawEvent({
    "event": "click_menu",
    "interaction": {
      "interaction_location": "primary menu",
      "click_type": "menu",
      "link_url": e.currentTarget.getAttribute("href"),
      "link_text": e.currentTarget.textContent,
      "option": 1
    }
  });
});

secondLevelMenuItem.on("click", (e) => {
  Analytics.sendRawEvent({
    "event": "click_menu",
    "interaction": {
      "interaction_location": "primary menu",
      "click_type": "menu",
      "link_url": e.currentTarget.getAttribute("href"),
      "link_text": e.currentTarget.textContent,
      "option": 2
    }
  });
});

mobileFirstLevelMenuItem.on("click", (e) => {
  Analytics.sendRawEvent({
    "event": "click_menu",
    "interaction": {
      "interaction_location": "primary menu",
      "click_type": "menu",
      "link_url": e.currentTarget.getAttribute("href"),
      "link_text": e.currentTarget.textContent,
      "option": 1
    }
  });
});

mobileSecondLevelMenuItem.on("click", (e) => {
  Analytics.sendRawEvent({
    "event": "click_menu",
    "interaction": {
      "interaction_location": "primary menu",
      "click_type": "menu",
      "link_url": e.currentTarget.getAttribute("href"),
      "link_text": e.currentTarget.textContent,
      "option": 2
    }
  });
});

/* Third level menus are asynchronous so not available as soon as the page load */

const trackInstanciedThirdLevelMenuItem = () => {
  let thirdLevelMenuItem = $('[menu-item-link-primary-level-3]');

  thirdLevelMenuItem.off();

  thirdLevelMenuItem.on("click", (e) => {

    Analytics.sendRawEvent({
      "event": "click_menu",
      "interaction": {
        "interaction_location": "primary menu",
        "click_type": "menu",
        "link_url": e.currentTarget.getAttribute("href"),
        "link_text": e.currentTarget.textContent,
        "option": 3
      }
    });
  });
}

const trackInstanciedThirdLevelMenuMobileItem = () => {
  let mobileThirdLevelMenuItem = $('[mobile-menu-item-link-primary-level-3]');

  mobileThirdLevelMenuItem.off();

  mobileThirdLevelMenuItem.on("click", (e) => {

    Analytics.sendRawEvent({
      "event": "click_menu",
      "interaction": {
        "interaction_location": "primary menu",
        "click_type": "menu",
        "link_url": e.currentTarget.getAttribute("href"),
        "link_text": e.currentTarget.textContent,
        "option": 3
      }
    });
  });

}


export { trackInstanciedThirdLevelMenuItem, trackInstanciedThirdLevelMenuMobileItem }